import { styled } from '@mui/material';

export const UniversityName = styled('p')(({ theme }) => ({
  margin: 0,
}));

export const CourseAdminName = styled('p')(({ theme }) => ({
  margin: 0,
}));
